import React, { Component } from 'react';
import PropTypes from 'prop-types';

import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrCardOld from 'client/components/SrCardOld';
import SrEmoji from 'client/components/SrEmoji';

class SrApartmentSpecialDealsList extends Component {
  static propTypes = {
    apartmentSpecialDeals: PropTypes.array.isRequired,
    apartmentUnit: PropTypes.string,
    floorPlanId: PropTypes.number,
    showAllFloorPlanDeals: PropTypes.bool,
  }

  render() {
    const {
      apartmentUnit,
      showAllFloorPlanDeals,
      floorPlanId,
      apartmentSpecialDeals,
    } = this.props;

    const nowMoment = momentWithAustinTimezone();

    const dealsSubset = (apartmentUnit
      ? (
        apartmentSpecialDeals.filter((specialDeal) => {
          return (
            (specialDeal.applicableApartmentUnits || []).length === 0
            || specialDeal.applicableApartmentUnits.includes(apartmentUnit)
          );
        })
      )
      : (
        apartmentSpecialDeals.filter((specialDeal) => {
          return (specialDeal.applicableApartmentUnits || []).length === 0;
        })
      )
    ).filter((apartmentSpecialDeal) => (
      (
        !apartmentSpecialDeal.endDate
        || nowMoment.isBefore(apartmentSpecialDeal.endDate)
      )
      && (
        showAllFloorPlanDeals
        || !apartmentSpecialDeal.floorPlanId
        || apartmentSpecialDeal.floorPlanId === floorPlanId
      )
    ));

    if (!dealsSubset.length) {
      return null;
    }

    return (
      <SrBox className='SrApartmentSpecialDealsList'>
        <SrText font='whitney-sc' weight='bold'>special deals</SrText>
        <SrBox className='list'>
          {dealsSubset.map((specialDeal) => (
            <SrCardOld key={specialDeal.id} className='SrApartmentSpecialDealCard'>
              <SrFlex className='cardHeader' justify='between'>
                <SrBox>
                  <SrText color='green' size='2xl' weight='bold' display='block'>
                    {specialDeal.headline}
                  </SrText>
                  <SrText className='terms' color='green' font='whitney-sc'>
                    {specialDeal.terms}
                  </SrText>
                </SrBox>
                {specialDeal.emoji
                  ? (
                    <SrBox paddingTop={12}>
                      <SrEmoji className='emoji' emoji={specialDeal.emoji} />
                    </SrBox>
                  )
                  : <SrBox className='icon' />
                }
              </SrFlex>
              {specialDeal.description && (
                <SrBox className='description'>
                  <SrText>{specialDeal.description}</SrText>
                </SrBox>
              )}
            </SrCardOld>
          ))}
        </SrBox>
      </SrBox>
    );
  }
}

SrApartmentSpecialDealsList.displayName = 'SrApartmentSpecialDealsList';

export default SrApartmentSpecialDealsList;
